var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-cache',{ref:"cache",attrs:{"get-data":_vm.getItem,"id":_vm.$route.query.id},scopedSlots:_vm._u([{key:"default",fn:function({data}){return _c('LabelDetail',{attrs:{"form-data":data,"label-type-prop":_vm.$route.query.type}})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }